import React from 'react';
import {Typography, Layout,} from 'antd';
import {SignIn} from "../pages/SignIn";
import styles from "./BasicLayout.module.less"

const {Paragraph,} = Typography;
const {Content, Footer} = Layout;

function MadeWithLove() {
    return (
        <Paragraph>
            {'Built with love by the '}
            <a href="https://remerge.io/">
                Remerge
            </a>
            {' team.'}
        </Paragraph>
    );
}

function SignInLayout() {
    return (
        <Layout className={styles.rootLayout}>
            <Content
                style={{
                    padding: '200px 10px 0 10px',
                    background: '#fff',
                }}
            >
                <SignIn/>
            </Content>
            <Footer style={{textAlign: 'center'}}>
                <MadeWithLove/>
            </Footer>
        </Layout>
    );
}

export default SignInLayout;
